import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-f4401ad4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "no-auth",
  style: {"margin-right":"10px"}
}
const _hoisted_2 = ["href"]

import main from '@/data/main.js';

export default /*#__PURE__*/_defineComponent({
  __name: 'BackBtn',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", null, [
      _createElementVNode("a", {
        href: `${_unref(main).INIT_URL}/mi-muro`
      }, "Volver atrás", 8, _hoisted_2)
    ])
  ]))
}
}

})